import { Factory } from '../../services/Factory';

namespace app.directives.controls {
  import IAugmentedJQuery = angular.IAugmentedJQuery;

  export interface IBadgeScope extends angular.IScope {
  }

  export interface IBadgeAttributes extends angular.IAttributes {
  }

  export class Badge implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: IBadgeScope, element: IAugmentedJQuery, attrs: IBadgeAttributes) => void;
    public templateUrl = "partials/badge.html";
    public scope = {};

    constructor($rootScope: IRootScope, accountService: app.services.account.AccountService, organizationService: app.services.organization.OrganizationService) {
      this.link = (scope: IBadgeScope) => {
        scope.$watch("organization", newOrganization => {
          if (!_.isEmpty(newOrganization)) {
            scope.account = newOrganization;
          } else {
            scope.account = accountService.Get();
          }
        }, true);

        scope.organization = organizationService.GetCurrentOrganization();
        scope.$on("OrganizationService.CurrentOrganizationChanged", (event, organization) => scope.organization = organization);

        scope.$on("AccountService.accountUpdated", () => scope.gravatar = accountService.Get());
      };
    }
  }

  frontendApp.directive("iioBadge", ["$rootScope", "AccountService", "OrganizationService", Factory.Create(Badge)]);
}
